<template>
  <Card
    :title="$t('global.cloud-auto-scaling')"
    :help="{
      header: $t('global.cloud-auto-scaling'),
      message: $t('global.auto-scaling-help-message'),
      link: helpLink,
    }"
  >
    <LoadingState v-if="isLoading()" :size="50" />
    <ErrorState v-else-if="isErrored()" />
    <template v-else-if="site">
      <AutoScaling :plan="plan" :site="site" :disabled="isAdvancedAutoScaleEnabled()" />
      <template v-if="show()">
        <hr />
        <AdvancedAutoScaling :plan="plan" :site="site" :disabled="isAutoScaleEnabled()" />
      </template>
    </template>
  </Card>
</template>

<script>
import AdvancedAutoScaling from "@/components/smart/cards/AdvancedAutoScaling";
import AutoScaling from "@/components/smart/cards/AutoScaling";
import Card from "@/components/display/Card";
import { computed } from "@vue/composition-api";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import store from "@/store";

export default {
  name: "CloudAutoScaling",
  components: {
    AdvancedAutoScaling,
    AutoScaling,
    Card,
    ErrorState,
    LoadingState,
  },
  props: {
    plan: Object,
    planStatus: {
      type: Object,
      required: true,
    },
    site: Object,
    siteStatus: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const phpContainer = computed(() => store.getters["containers/getPhp"]);

    const helpLink = [
      new NavLink(
        root.$t("global.learn-more"),
        null,
        function () {
          window.open(
            "https://help.nexcess.net/client-portal/what-is-nexcess-cloud-auto-scaling?from_search=49181016",
            "_blank"
          );
        },
        false,
        null,
        null
      ),
    ];

    const isAdvancedAutoScaleEnabled = () => !!phpContainer.value;
    const isAutoScaleEnabled = () => props.site.environment.options.autoScaleEnabled;
    const isErrored = () => props.planStatus.isErrored || props.siteStatus.isErrored;
    const isLoading = () => props.planStatus.isLoading || props.siteStatus.isLoading;
    const show = () =>
      ["us-midwest-1", "us-west-1", "uk-south-2"].includes(props.plan.location.code);

    return {
      helpLink,
      isAdvancedAutoScaleEnabled,
      isAutoScaleEnabled,
      isErrored,
      isLoading,
      phpContainer,
      show,
    };
  },
};
</script>
